export default __webpack_public_path__ + "static/dividersangled-f3a82cdc46e0b62d0c38ad3938e3e4fa.png";